"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    "+353",
];
//# sourceMappingURL=country-dial-codes.js.map